const { NumberFormatter } = require('reduce-precision');

const metricFormatters = {
  usd: new NumberFormatter({ language: 'en', template: 'usd', precision: 'medium' }),
  percent: new NumberFormatter({ language: 'en', template: 'percent', precision: 'medium' }),
  number: new NumberFormatter({ language: 'en', template: 'number', precision: 'medium' }),
};

const COIN_CHART_METRICS = Object.freeze({
  price: 'قیمت',
  dominance: 'دامیننس (سهم از بازار)',
  circulating_supply: 'گردش در عرضه',
  market_cap: 'ارزش بازار',
  volume: 'حجم معاملات',
  volume_market_cap_ratio: 'نسبت حجم به ارزش بازار',
});

function normalizeMetricHistory(body) {
  if (body?.status !== 'success' || !Array.isArray(body.data)) throw new Error('Invalid metric response');
  const points = new Map();
  for (const point of body.data) {
    const time = Array.isArray(point) ? point[0] : point?.time;
    const value = Array.isArray(point) ? point[1] : point?.value;
    if (time == null || value == null || value === '' || !Number.isFinite(Number(time)) || !Number.isFinite(Number(value)) || Number(value) < 0) continue;
    points.set(Number(time), { x: Number(time), y: Number(value) });
  }
  const dollar = [...points.values()].sort((a, b) => a.x - b.x);
  if (!dollar.length) throw new Error('Empty metric response');
  const min = dollar.reduce((a, b) => a.y <= b.y ? a : b);
  const max = dollar.reduce((a, b) => a.y >= b.y ? a : b);
  return { dollar, toman: [], dmin: { ...min }, dmax: { ...max }, tmin: { ...min }, tmax: { ...max }, pointsRange: dollar.length > 1 ? dollar[1].x - dollar[0].x : 0 };
}

// Highcharts' default single-value expansion uses absolute units, which is
// unsuitable for tiny percentages and supplies above Number.MAX_SAFE_INTEGER.
function getMetricAxisBounds(min, max, logarithmic = false, mobile = false) {
  if (!Number.isFinite(min) || !Number.isFinite(max) || min > max) return null;
  if (logarithmic && min <= 0) return null;
  const paddingRatio = mobile ? 0.2 : 0.08;
  if (min === max) {
    if (min === 0) return { min: 0, max: 1 };
    const padding = Math.max(Math.abs(min) * 0.02, Number.MIN_VALUE);
    return { min: Math.max(0, min - padding), max: max + padding };
  }
  if (logarithmic) {
    const padding = (Math.log(max) - Math.log(min)) * paddingRatio;
    return { min: Math.exp(Math.log(min) - padding), max: Math.exp(Math.log(max) + padding) };
  }
  const padding = Math.max((max - min) * paddingRatio, Math.abs(max) * Number.EPSILON * 8);
  return { min: Math.max(0, min - padding), max: max + padding };
}

function formatMetricValue(value, metric, symbol = '') {
  if (metric === 'market_cap' || metric === 'volume') return metricFormatters.usd.toString(value);
  if (metric === 'dominance') return metricFormatters.percent.toString(value);
  const number = metricFormatters.number.toString(value);
  if (metric === 'circulating_supply') return `${number} ${String(symbol).replace(/[^a-zA-Z0-9._-]/g, '')}`;
  return number;
}

module.exports = { COIN_CHART_METRICS, normalizeMetricHistory, formatMetricValue, getMetricAxisBounds };
